import { render } from "./ProductSuggestionCard.vue?vue&type=template&id=7f8c0da7&scoped=true"
import script from "./ProductSuggestionCard.vue?vue&type=script&lang=js"
export * from "./ProductSuggestionCard.vue?vue&type=script&lang=js"

import "./ProductSuggestionCard.vue?vue&type=style&index=0&id=7f8c0da7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8c0da7"]])

export default __exports__